<template>
  <b-container fluid class="theme-blue">
    <div class="page-header">
      <Navbar text="Account Settings" />
    </div>

    <section>
      <h2>{{ card_title_my_subscription }}</h2>

      <b-table
        :fields="fields"
        :items="subscriptions"
        :busy="isBusy"
        class="table-sm"
        borderless
      >
        <div slot="table-busy" class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
    </section>

    <section>
      <h2>{{ card_title_upgrade_subscription }}</h2>

      <div v-if="!isBusyForSubscription && !paymentCookieExist">
        <p>Ready for more?</p>

        <b-button variant="primary" :to="{ name: 'Checkout' }">
          Upgrade
        </b-button>
      </div>

      <div v-if="!isBusyForSubscription && paymentCookieExist">
        <p>Payment process is in progress.</p>

        <h2>Need help?</h2>

        <router-link to="/Support" class="btn btn-blue">
          Contact Us
        </router-link>
      </div>
    </section>

    <section>
      <div class="row">
        <div class="col-sm-6">
          <h2>Users</h2>      
        </div>
        <div class="col-sm-6 text-right">
          <b-button variant="primary" v-b-modal.modal-1>
            Add User
          </b-button>
        </div>
      </div>

      <div class="table-responsive">
        <b-table
          :fields="userFields"
          :items="users"
          :busy="isBusyUser"
          class="table-striped dataTable"
        >
          <div slot="table-busy" class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
          <template #cell(removelink)="data">
            <a
              href="javascript:void(0)"
              @click="removeUser(data.item.username)"
            >
              <span class="icon icon-trash" />
            </a>
          </template>
        </b-table>
      </div>
    </section>

    <!-- Modal templates -->
    <!-- Add User-->
    <b-modal
      id="modal-1"
      size="lg"
      centered
      role="dialog"
      modal-class="regular"
      hide-header-close
      hide-footer
    >
      <template slot="modal-header" slot-scope="{ close }">
        <h5 class="modal-title">Add New User</h5>
        <button type="button" class="close" @click="close()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <template slot="default" slot-scope="{ hide }">
        <b-container class="m-0 p-0">
          <b-form @submit="addNewUser">
            <b-container>
              <b-row>
                <b-col sm="0" cols="7">
                  <b-form-input
                    type="email"
                    required
                    v-model="newUserUsername"
                    placeholder="Enter user email"
                    class="input-text"
                  />
                </b-col>
                <b-col sm="0" cols="3">
                  <b-form-select
                    v-model="selectedRole"
                    :options="roles"
                    size="md"
                  ></b-form-select>
                </b-col>
                <b-col sm="0" cols="2">
                  <b-button type="submit" variant="black">Add</b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-form>
        </b-container>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import Navbar from "../Navigation/Navbar";
import {
  getSubscriptionInfo,
  getUsersList,
  addUser,
  removeUser,
} from "../../services/api.service";
import * as formatUtils from "@/utils/format-utils";

export default {
  name: "Subscriptions",
  components: {
    Navbar,
  },
  data() {
    return {
      card_title_my_subscription: "My Subscription",
      card_title_upgrade_subscription: "Upgrade Subscription",
      fields: [
        {
          key: "tier",
          label: "Subscription Plan",
          formatter: "formatSubscriptionTier",
        },
        {
          key: "type",
          label: "Billing Frequency",
          formatter: "formatSubscriptionType",
        },
        { key: "endDate", label: "Expiration Date", formatter: "formatDate" },
        {
          key: "modelNo",
          label: "Max. # Models",
          formatter: "formatSubscriptionLimit",
        },
        {
          key: "activeModelsLimit",
          label: "Max. # Active Models",
          formatter: "formatSubscriptionLimit",
        },
        {
          key: "modelAnimationsLimit",
          label: "Max. # Animations per Model",
          formatter: "formatSubscriptionLimit",
        },
        {
          key: "companionModelsLimit",
          label: "Max. # Companion Models",
          formatter: "formatSubscriptionLimit",
        },
        {
          key: "brochuresLimit",
          label: "Max. # Brochures",
          formatter: "formatSubscriptionLimit",
        },
        {
          key: "webARModelsLimit",
          label: "Max. # Web AR Models",
          formatter: "formatSubscriptionLimit",
        },
        {
          key: "webAREmbedsLimit",
          label: "Max. # Web AR Embeds",
          formatter: "formatSubscriptionLimit",
        },
      ],
      userFields: [
        { key: "username", label: "Email", sortable: true },
        {
          key: "role",
          label: "Role",
          formatter: "formatUserRole",
          sortable: true,
        },
        { key: "removelink", label: "" },
      ],
      roles: [
        { value: "user", text: "User" },
        { value: "admin", text: "Admin" },
      ],
      selectedRole: "user",
      subscriptions: [],
      users: [],
      isBusy: true,
      isBusyUser: true,
      newUserUsername: "",
      subscriptionActive: false,
      isBusyForSubscription: true,
      paymentCookieExist: false,
    };
  },
  methods: {
    formatDate: formatUtils.formatDate,
    formatSubscriptionTier: formatUtils.formatSubscriptionTier,
    formatSubscriptionType: formatUtils.formatSubscriptionType,
    formatSubscriptionLimit: formatUtils.formatSubscriptionLimit,
    formatUserRole: formatUtils.formatUserRole,
    addNewUser(evt) {
      evt.preventDefault();

      this.$AuthService.getAccessToken(
        function () {
          addUser(
            this.newUserUsername,
            this.selectedRole,
            this.$AuthService.token.accessToken
          ).then(() => {
            this.isBusyUser = true;
            getUsersList(this.$AuthService.token.accessToken)
              .then((x) => {
                this.users = x;
              })
              .then(() => {
                this.isBusyUser = false;
                this.$root.$emit("bv::hide::modal", "modal-1");
                this.newUserUsername = "";
              });
          });
        }.bind(this)
      );
    },
    removeUser(username) {
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to remove this user?", {
          title: "Remove User",
          size: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelVariant: "black",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
          modalClass: "regular",
        })
        .then((value) => {
          this.boxTwo = value;

          if (value)
            this.$AuthService.getAccessToken(
              function () {
                removeUser(username, this.$AuthService.token.accessToken).then(
                  () => {
                    this.isBusyUser = true;

                    getUsersList(this.$AuthService.token.accessToken)
                      .then((x) => {
                        this.users = x;
                      })
                      .then(() => {
                        this.isBusyUser = false;
                      });
                  }
                );
              }.bind(this)
            );
        });
    },
  },
  created: function () {
    var paymentCookie = this.$cookie.get("payment");

    if (paymentCookie != null) {
      this.paymentCookieExist = true;
    }

    this.$AuthService.getAccessToken(
      function () {
        getSubscriptionInfo(this.$AuthService.token.accessToken)
          .then((x) => {
            this.subscriptions.push(x);
            this.subscriptionActive = x.isActive;
          })
          .catch((x) => {
            this.subscriptionActive = false;
          })
          .then(() => {
            this.isBusy = false;
            this.isBusyForSubscription = false;
          });

        getUsersList(this.$AuthService.token.accessToken)
          .then((x) => {
            this.users = x;
          })
          .then(() => {
            this.isBusyUser = false;
          });
      }.bind(this)
    );
  },
};
</script>
